export default __webpack_public_path__ + "static/media/1000L.90ac89b2.png";